export default function Footer() {
  const modules = [
    { label: '焦点专题', href: '#carousel' },
    { label: '热门话题', href: '#topics' },
    { label: '投稿爆料', href: '#contact' },
    { label: '主题索引', href: '#index' },
    { label: '热度榜单', href: '#ranking' },
    { label: '平台特色', href: '#features' },
    { label: '吃瓜精选', href: '#cards' },
    { label: '关于我们', href: '#about' },
    { label: '常见问题', href: '#faq' },
    { label: '最新动态', href: '#updates' },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <span className="text-xl font-heading font-extrabold text-background-50">
              <span className="text-primary-400">51</span>吃瓜爆料网
            </span>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
              全网最热吃瓜短视频聚集地，整理台北娜娜、玩偶姐姐、莫里秀等网红热梗合集，直击吃瓜娱乐现场与网红直播翻车片段。每日更新，精彩不断。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-100 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-100 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-100 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {modules.slice(0, 5).map((m) => (
                <li key={m.href}>
                  <a
                    href={m.href}
                    onClick={(e) => handleClick(e, m.href)}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {m.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">更多内容</h3>
            <ul className="space-y-2.5">
              {modules.slice(5).map((m) => (
                <li key={m.href}>
                  <a
                    href={m.href}
                    onClick={(e) => handleClick(e, m.href)}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {m.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-400">敬请期待</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 51吃瓜爆料网. 本站内容仅供娱乐，不构成任何建议。
          </p>
          <p className="text-xs text-foreground-500">
            热播吃瓜短视频 · 吃瓜娱乐现场 · 网红直播翻车
          </p>
        </div>
      </div>
    </footer>
  );
}